import React, { useEffect } from "react";
import { repTop30Selector, userDataSelector, categorySelector } from "@app-redux/selectors";
import { useAppDispatch, useAppSelector } from "@app-redux/store";
import { getRepTop30 } from "@app-redux/thunk/repTop30Thunk";
import { setSelectedRep } from "@app-redux/slices/repTop30Slice";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import styles from "./styles.module.css";

export const RepSelector = () => {
  const dispatch = useAppDispatch();
  const { selectedRep } = useAppSelector(repTop30Selector);
  const { data: categories } = useAppSelector(categorySelector);
  const userData = useAppSelector(userDataSelector);
  const currentUserName = userData.data?.full_name;
  const isReader = userData.data?.roles?.includes("WikiReader");

  const repCategory = categories.find((cat) => cat.name === "Rep");
  const reps = repCategory?.items ?? [];

  useEffect(() => {
    if (reps.length && !selectedRep && isReader && currentUserName) {
      const userInList = reps.find(
        (r) => r.name.toLowerCase() === currentUserName.toLowerCase()
      );
      if (userInList) {
        dispatch(setSelectedRep({ id: userInList.id, name: userInList.name }));
      }
    }
  }, [reps, selectedRep, currentUserName, isReader]);

  useEffect(() => {
    if (selectedRep) {
      dispatch(getRepTop30({ repId: selectedRep.id }));
    }
  }, [selectedRep]);

  const handleSelect = (repId: string, repName: string) => {
    dispatch(setSelectedRep({ id: repId, name: repName }));
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.title}>REPS</span>
      </div>
      {reps.length === 0 ? (
        <p className={styles.emptyMessage}>No reps found.</p>
      ) : (
        <List disablePadding className={styles.list}>
          {reps.map((rep) => (
            <ListItem key={rep.id} disablePadding>
              <ListItemButton
                selected={selectedRep?.id === rep.id}
                onClick={() => handleSelect(rep.id, rep.name)}
              >
                <ListItemText primary={rep.name} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      )}
    </div>
  );
};
